<template>
  <v-dialog v-model="dialogUpdateGroupName" persistent max-width="600px">
    <v-card class="pa-4">
      <v-card-title>
        <span class="dialog-member-title">แก้ไขชื่อกลุ่ม</span>
        <v-row justify="end" style="margin-top: -3%;">
          <v-btn
            x-small
            icon
            @click="closeDialog()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row justify="center">
          <v-col cols="12" class="mt-n2">
            <v-divider></v-divider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-form ref="form">
              <v-row class="pl-5 pr-5 pt-2 pb-2 mb-n2">
                <v-col cols="12" class="form-control pa-2">
                  <span>ชื่อกลุ่ม</span>
                  <v-text-field
                    v-model="positionGroupName"
                    dense
                    outlined
                    @input="handleInputChange(positionGroupName)"
                    @keydown="validateKeydown($event)"
                    placeholder="ชื่อกลุ่ม"
                    :rules="[(v) => !!v || 'กรุณากรอกชื่อกลุ่ม']"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="button-color-outline" dark outlined @click="closeDialog()">ยกเลิก</v-btn>
        <v-btn v-if="checkValueList === false || isDuplicate || isCheckDuplicate" class="button-color" color="grey" disabled>บันทึกข้อมูล</v-btn>
        <v-btn v-else class="button-color" dark @click="submitData()">บันทึกข้อมูล</v-btn>
      </v-card-actions>
      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="snackbarColor"
        absolute
        text
        top
        app
      >
        <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
        <span :style="{ color: `${snackbarColor}` }">{{ text }}</span>
      </v-snackbar>
    </v-card>
  </v-dialog>
</template>

<script>
import { validateDuplicateGroupName, updatePositionLevelGroupName } from '@/API/API'
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'

export default {
  data () {
    return {
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      dialogUpdateGroupName: false,
      positionGroupName: '',
      positionGroupId: '',
      debounceTimeout: null,
      isDuplicate: false,
      isCheckDuplicate: false,
      token: ''
    }
  },
  computed: {
    checkValueList () {
      return this.positionGroupName !== ''
    }
  },
  mounted () {
    EventBus.$on('opendialogUpdateGroupName', this.openDialogUpdateGroupName)
  },
  beforeDestroy () {
    EventBus.$off('opendialogUpdateGroupName')
  },
  methods: {
    openDialogUpdateGroupName (data) {
      this.positionGroupId = data._id
      this.positionGroupName = data.positionGroupName
      this.token = this.$store.state.token
      this.dialogUpdateGroupName = true
    },
    closeDialog () {
      this.dialogUpdateGroupName = false
    },
    validateKeydown (event) {
      const key = event.key
      const cursorPos = event.target.selectionStart
      if (key === 'Backspace' || /[0-9a-zA-Zก-๙]/.test(key)) {
        return
      }
      if (key === ' ') {
        if (cursorPos === 0) {
          event.preventDefault()
        }
        return
      }
      event.preventDefault()
    },
    handleInputChange (value) {
      this.isCheckDuplicate = true
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout)
      }
      this.debounceTimeout = setTimeout(async () => {
        if (value && value !== '') {
          this.positionGroupName = value.trim()
          await this.validateDuplicateGroupName(this.positionGroupName)
          if (this.isDuplicate) {
            this.text = 'ชื่อกลุ่ม ซ้ำกับภายในระบบ'
            this.snackbarColor = 'error'
            this.snackbar = true
          }
          this.isCheckDuplicate = false
        }
      }, 500)
    },
    async validateDuplicateGroupName (positionGroupName) {
      try {
        const res = await validateDuplicateGroupName(positionGroupName, this.token)
        if (res.success) {
          this.isDuplicate = false
        } else {
          this.isDuplicate = true
        }
      } catch (error) {
        this.isDuplicate = false
        console.error('error message => ', error)
      }
    },
    async submitData () {
      if (this.$refs.form.validate() && !this.isDuplicate) {
        const data = {
          id: this.positionGroupId,
          positionGroupName: this.positionGroupName
        }
        try {
          const res = await updatePositionLevelGroupName(data, this.token)
          if (res.success) {
            swal('สำเร็จ', 'เพิ่มกลุ่มระดับตำแหน่งงานสำเร็จ', 'success', {
              button: false,
              timer: 2000
            })
            this.closeDialog()
          }
          EventBus.$emit('closedialogUpdateGroupName')
        } catch (error) {
          console.error('error message => ', error)
        }
      }
    }
  }
}
</script>

<style scoped></style>
